var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-special", style: _vm.cssVars }, [
    _c("div", { staticClass: "mobile-section-title" }, [_vm._v("专题")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-special__list" },
      _vm._l(_vm.specialList, function (item, index) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "mobile-special__item",
            class: "mobile-special__item--" + item.id,
            on: {
              click: function ($event) {
                return _vm.handleClick(item)
              },
            },
          },
          [
            _c("div", { staticClass: "mobile-special__content" }, [
              _c("div", { staticClass: "mobile-special__num" }, [
                _vm._v(_vm._s(item.eduLevel)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mobile-special__name" }, [
                _vm._v(_vm._s(item.resourceData)),
              ]),
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "mobile-special__icon",
              attrs: { src: _vm.getTopicIcon(item.id), alt: "" },
            }),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }